import styled from 'styled-components';

import { Heading } from '@dreryk/react-components';

export const StyledPrescriptionListHeaderHeading = styled(Heading)`
   grid-column: 1 / span 2;
`;
